// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ConfigurationService } from '../services/configuration-service';
import {Store} from '@ngrx/store';
import {AppState, logout} from '../app/store/app.state';

@Injectable()
export class HttpsRequestInterceptor implements HttpInterceptor {
  public readonly jwtHelper = inject(JwtHelperService);
  public configService = inject(ConfigurationService);
  private readonly store = inject(Store<AppState>)

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Don't send Auth header for rest APi calls when we don't have a JWT token.
    const token = localStorage.getItem('token');

    if (token) {
      let expired: boolean;

      try {
        expired = this.jwtHelper.isTokenExpired(token as string);
      } catch {
        console.error('token issue, is your system time not synced?');
        expired = true;
      }
      
      if (req.url.endsWith('/api/v1/login') && expired) {
        this.store.dispatch(logout())
        localStorage.removeItem('token');
      } else {
        let cacheControl = '';

        if (this.configService.apiUrl && req.url.startsWith(this.configService.apiUrl)) {
            cacheControl = 'no-cache, no-store, must-revalidate';
        }

        if (!req.headers.has('Authorization')) {
          req = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            },
          });
        }

        req = req.clone({
          setHeaders: {
            'Cache-Control': cacheControl
          },
        });
      }
    }

    req = req.clone({
      setHeaders: {
        'Accept-Language': localStorage.getItem('language') || 'en'
      },
    });

    return next.handle(req);
  }
}
